import { Reveal } from "./Reveal";

export default function WarumHypno() {
  return (
    <section data-testid="warum-hypno-section" className="bg-cream px-6 md:px-14 py-20 md:py-28">
      <div className="max-w-3xl mx-auto">
        <Reveal>
          <p className="text-xs md:text-sm font-medium uppercase tracking-[0.32em] text-bronze mb-6">
            Warum Hypnomeditation?
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-serif tracking-tight text-2xl md:text-4xl leading-tight text-espresso">
            Was passiert während einer Hypnomeditation?
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-10 text-base md:text-lg font-light leading-relaxed text-taupe">
            Eine Hypnomeditation verbindet Elemente einer geführten Meditation mit
            hypnotischer Trance und gezielten Suggestionen.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Du darfst zunächst zur Ruhe kommen. Dein Körper entspannt sich, dein Atem
            kann ruhiger werden und deine Aufmerksamkeit richtet sich zunehmend nach
            innen.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Dabei nutzen wir gezielt den hypnotischen Zustand. Du schläfst nicht,
            bist ansprechbar und behältst jederzeit die Kontrolle.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Unser bewusster Verstand analysiert, bewertet und hinterfragt permanent.
            In der Hypnose sprechen wir dabei vom «kritischen Faktor». In hypnotischer
            Trance kann dieses ständige Analysieren stärker in den Hintergrund treten.
            Dadurch können wir gezielt mit Suggestionen, inneren Bildern und
            Vorstellungen arbeiten.
          </p>
          <p className="mt-5 text-base md:text-lg font-light leading-relaxed text-taupe">
            Viele emotionale Reaktionen und erlernte Muster laufen automatisch ab. In
            der Hypnose sprechen wir in diesem Zusammenhang häufig vom
            Unterbewusstsein.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <div className="mt-12 border-l-2 border-gold pl-6 md:pl-8">
            <p className="font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight">
              Bewusst möchtest du loslassen. Doch dein Inneres reagiert vielleicht
              noch nach einem alten Muster.
            </p>
            <p className="mt-4 text-base md:text-lg font-light leading-relaxed text-taupe">
              Durch hypnotische Suggestionen können neue innere Vorstellungen und
              Reaktionsmöglichkeiten angeboten und verankert werden. Das wird in der
              Hypnosetherapie häufig als «Neuprogrammierung» bezeichnet.
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.3}>
          <p className="mt-12 font-serif italic text-xl md:text-2xl leading-snug text-espresso tracking-tight">
            Du kannst nicht verändern, was passiert ist.<br />
            Aber du kannst verändern, wie dein Inneres heute darauf reagiert.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
